module.exports = __webpack_public_path__ + "img/carousel-mobile-3.f584866e.svg";